"use strict";
/*
 * Copyright (C) 2021 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovClient = exports.StaticSeed = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
__exportStar(require("./proposal"), exports);
__exportStar(require("./realm"), exports);
__exportStar(require("./voter"), exports);
const JET_GOV_PROGRAM_ID = new web3_js_1.PublicKey("5TBwvU5xoA13fzmZgWVgFBUmBz1YCdiq2AshDZpPn3AL"); // FIXME: deploy program
exports.StaticSeed = {
    RealmAuthority: Buffer.from("realm-authority"),
    Vault: Buffer.from("vault"),
    Voter: Buffer.from("voter")
};
class GovClient {
    constructor(program) {
        this.program = program;
    }
    static async connect(provider) {
        const idl = await anchor_1.Program.fetchIdl(JET_GOV_PROGRAM_ID, provider);
        return new GovClient(new anchor_1.Program(idl, JET_GOV_PROGRAM_ID));
    }
    deriveRealmAuthority(realm) {
        return web3_js_1.PublicKey.findProgramAddress([exports.StaticSeed.RealmAuthority, realm.toBuffer()], this.program.programId);
    }
    deriveVault(realm) {
        return web3_js_1.PublicKey.findProgramAddress([exports.StaticSeed.Vault, realm.toBuffer()], this.program.programId);
    }
    deriveVoter(realm, wallet) {
        return web3_js_1.PublicKey.findProgramAddress([exports.StaticSeed.Voter, wallet.toBuffer(), realm.toBuffer()], this.program.programId);
    }
}
exports.GovClient = GovClient;
//# sourceMappingURL=index.js.map